import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const GoalType = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    { key: "1", type: "Project Goals", desc: "Goals related to completing projects", status: "Active" },
    { key: "2", type: "Target Goals", desc: "Goals based on performance targets", status: "Active" },
    { key: "3", type: "Project Goals", desc: "Specific goals linked to projects", status: "Active" },
    { key: "4", type: "Project Goals", desc: "Goals that drive improvement", status: "Active" },
  ];

  const filteredData = data.filter((item) =>
    item.type.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Type", dataIndex: "type" },
    { title: "Description", dataIndex: "desc" },
    { title: "Status", dataIndex: "status" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Goal Type List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default GoalType;